<template>
  <section class="hero-reports">
    <div class="container">
      <div class="hero-reports__layout">
        <div :class="['hero-reports__content',
          { 'hero-reports__content--extra-spacing': addContentSpacing }
        ]">
          <p class="hero-reports__subheading"><slot name="subheading"/></p>
          <h1 class="hero-reports__title"><slot name="title"/></h1>
          <p class="hero-reports__text">
            <slot name="text"/>
          </p>
        </div>
        <div class="hero-reports__image-wrapper">
          <slot name="image" />
        </div>
      </div>
    </div>  
  </section>
</template>

<script lang="ts" setup>
interface Props {
  addContentSpacing?: boolean
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
@keyframes slide-in {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.hero-reports {
  margin-bottom: 64px;

  @media (min-width: $breakpoint-md) {
    margin-bottom: 96px;
  }

  @media (min-width: $breakpoint-lg) {
    height: 390px;
    box-sizing: content-box;
  }

  &__subheading {
    @include heading-subheading;

    margin-bottom: 20px;
  }

  &__title {
    font-size: var(--font-size-heading-title);
  }

  &__text {
    font-size: var(--font-size-paragraph-l);
    margin-bottom: 0;
  }

  &__content {
    margin-bottom: 56px;
    animation: slide-in 0.6s ease-out forwards;

    @media(min-width: $breakpoint-lg) {
      max-width: 574px;
      margin-bottom: 0;
    }

    &--extra-spacing {
      @media (min-width: $breakpoint-lg) {
        padding-top: 72px;
      }
    }
  }

  &__layout {
    position: relative;
  }

  &__image-wrapper {
    display: flex;
    justify-content: flex-end;

    @media (min-width: $breakpoint-lg) {
      justify-content: none;
    }
  }
}
</style>